export const pc_brands = ["ARY", "KBE", "OTHER"];

export const coin_weights = [
  "0.500 GRM",
  "1.00 GRM",
  "2.00 GRM",
  "4.00 GRM",
  "8.00 GRM",
];

export const bar_brands = ["KWE", "MILLAT", "KBE"];

export const bar_weights = [
  "1.00 grm",
  "2.500 grm",
  "5.00 grm",
  "5.832 grm",
  "10.00 grm",
  "11.664 grm",
  "15.550 grm",
  "20.00 grm",
  "23.328 grm",
  "31.100 grm",
  "50.00 grm",
  "58.320 grm",
  "100.00 grm",
];

export const silverbar_brands = ["PSL", "KBE", "ASR", "SILVORA", "BMW"];

export const silverbar_weights = [
  "11.664 grm",
  "58.320 grm",
  "116.64 grm",
  "500.00 grm",
  "1000.00 grm",
  "1166.400 grm",
];
